import { css } from "@emotion/core";
import { FONTS } from "shared/styles/base";

export const modalCss = css`
    width: 680px;
    height: 371px;
    object-fit: contain;
    display: flex;
    background-color: #fff;

    @media (max-width: 768px) {
        width: 300px;
        height: 468px;
    }
`;

export const GDPRModalContentCss = css`
    display: flex;
    font-family: ${FONTS.CERA};

    @media (max-width: 768px) {
        display: block;
    }

    .main-image {
        width: 371px;
        height: 371px;
        float: left;
        @media (max-width: 768px) {
            width: 300px;
            height: 231px;
            margin-bottom: 12px;
        }
    }

    p {
        margin: 0 0 32px;
    }

    .GDPRContent {
        flex: 1;
        align-content: center;
        text-align: center;
        margin: auto;
    }

    .title {
        font-weight: 500;
        font-size: 16px;
        line-height: 1.19;
        color: #000;
        padding: 0 28px;

        @media (max-width: 768px) {
            font-size: 14px;
            line-height: 1.36;
            margin: 0 24px;
            margin-bottom: 8px;
            padding: 0;
        }
    }

    .btn {
        position: relative;
        width: 232px;
        height: 45px;
        text-align: center;
        font-size: 14px;
        font-weight: bold;
        cursor: pointer;
        border: 0;
        border-radius: 2px;
        margin-bottom: 20px;
        outline: none;

        @media (max-width: 768px) {
            width: 260px;
            height: 40px;
            margin: 5px 20px 5px 20px;
        }
    }

    .btn-primary {
        background: #000;
        color: #fff;
    }

    .btn-secondary {
        border: 1px solid black;
        background: #fff;
        color: #000;
    }

    .policy-text {
        line-height: 1.17;
        margin-top: 10px;
        font-size: 12px;
        margin: 0 25px;

        @media (max-width: 768px) {
            margin: 10px 25px;
        }
    }
`;
